import {useMemo} from 'react';
import {
  useIsFeatureEnabled,
  useIsFreeOrListBuilderCustomer,
} from '../../hooks/api/metadata';
import {GetStarted} from './GetStarted';
import {LookalikeSelection} from './LookalikeSelection';
import {SamFilter} from './SamFilter';
import {SetRole} from './SetRole';
import {SetWebsite} from './SetWebsite';
import {TemplatePicker} from './TemplatePicker';
import {InstallWebIntent} from './InstallWebIntent';
import {ConnectLinkedIn} from './ConnectLinkedIn';

type OnboardingStep = {
  name: string;
  route: string;
  element: React.ElementType;
  sidebar?: {
    image: string;
    text: string;
  };
};

export const useOnboardingSteps = (): OnboardingStep[] => {
  const freemiumV3 = useIsFeatureEnabled('freemiumV3');
  const isFreeOrListBuilderCustomer = useIsFreeOrListBuilderCustomer();

  return useMemo(
    () =>
      [
        {
          name: 'Get Started',
          route: '',
          element: GetStarted,
          condition: true,
        },
        {
          name: 'SAM Set',
          route: 'filters',
          element: SamFilter,
          sidebar: {
            image: '/Keyplay_Find.svg',
            text: 'Your Serviceable Market defines the boundaries of customers you can serve.',
          },
          condition: true,
        },
        {
          name: 'Lookalike Set',
          route: 'lookalikes',
          element: LookalikeSelection,
          sidebar: {
            image: '/Keyplay_Score.svg',
            text: 'Your Lookalike list will help you score ICP accounts.',
          },
          condition: true,
        },
        {
          name: 'Website Set',
          route: 'website',
          element: SetWebsite,
          sidebar: {
            image: '/Keyplay_Website.svg',
            text: 'Keyplay uses AI to zoom in on your Serviceable Market and pinpoint companies in your ICP.',
          },
          condition: isFreeOrListBuilderCustomer && freemiumV3,
        },
        {
          name: 'Install Web Intent',
          route: 'intent',
          element: InstallWebIntent,
          sidebar: {
            image: '/Keyplay_Intent.svg',
            text: 'The Keyplay snippet only tracks visitor intent, and has no impact on site performance.',
          },
          condition: isFreeOrListBuilderCustomer && freemiumV3,
        },
        {
          name: 'Connect LinkedIn',
          route: 'linkedin',
          element: ConnectLinkedIn,
          sidebar: {
            image: '/Keyplay_LinkedIn.svg',
            text: 'Using LinkedIn Ads impressions and clicks, understand progression of accounts through your marketing funnel.',
          },
          condition: isFreeOrListBuilderCustomer && freemiumV3,
        },
        {
          name: 'Template Set',
          route: 'template',
          element: TemplatePicker,
          condition: isFreeOrListBuilderCustomer && !freemiumV3,
        },
        {
          name: 'Role Set',
          route: 'role',
          element: SetRole,
          condition: true,
        },
      ].filter((step) => step.condition),
    [freemiumV3, isFreeOrListBuilderCustomer]
  );
};
